import store from "../store";
import verFlavor from "@/appFlavorAndVersion";


export function storeUserInfo(data) {
  localStorage.setItem('userId', data['userId'])
  localStorage.setItem('deviceId', data['deviceId'])
  localStorage.setItem('name', data['name'])
  localStorage.setItem('accessToken', data['accessToken'])
  localStorage.setItem('refreshToken', data['refreshToken'])
  localStorage.setItem('organizationId', data['organizationId'] === "" ? 1 : data['organizationId'])
  localStorage.setItem('appFlavour', verFlavor.APP_FLAVOR)
}

export function storeUserDeviceInfo(data){
  localStorage.setItem('deviceId', data['deviceId'])
}

export function storeLoggedInFlag(flag) {
  localStorage.setItem('isUserLoggedIn', flag)
}

export function storeUserCurrentDomain(domain) {
  localStorage.setItem('domainId', domain)
}

export function isUserLoggedIn() {
  return localStorage.getItem('isUserLoggedIn');
}

export function getLoggedInUserInfo() {
  return {
    userId: localStorage.getItem('userId'),
    deviceId: localStorage.getItem('deviceId'),
    name: localStorage.getItem('name'),
    accessToken: localStorage.getItem('accessToken'),
    refreshToken: localStorage.getItem('refreshToken'),
    organizationId: localStorage.getItem('organizationId'),
    appFlavour: localStorage.getItem('appFlavour'),
    appVersion: verFlavor.APP_VERSION,
    domainId: localStorage.getItem('domainId') ?? '',
  }
}

export function getLoggedInUserOrganizationId() {
  return localStorage.getItem('organizationId');
}

export function getLoggedInUserName() {
  return localStorage.getItem('name');
}

export function getLoggedInUserId() {
  return localStorage.getItem('userId');
}

export function getLoggedInUserOrganization() {
  return localStorage.getItem('organizationId');
}

export function getLoggedInUserCurrentDomain() {
  return localStorage.getItem('domainId') ?? '';
}

export function getDeviceId() {
  return localStorage.getItem('deviceId') ?? '';
}

export function getHeaders() {
  //console.log(`getHeaders | ${localStorage.getItem("organizationId")} | ${store.getters.defaultOrgnizationIdForFlavors}`)
  return {
    userid: localStorage.getItem('userId') ?? '',
    deviceid: localStorage.getItem('deviceId') ?? '',
    token: localStorage.getItem('accessToken') ?? '',
    organizationid: localStorage.getItem('organizationId') ?? store.getters.defaultOrganizationIdForFlavor,
    appflavour: localStorage.getItem('appFlavour') ?? verFlavor.APP_FLAVOR,
    appversion: verFlavor.APP_VERSION ?? '',
    domainid: localStorage.getItem('domainId'),
  }
}

export function logoutUser() {
  localStorage.removeItem('userId')
  //localStorage.removeItem('deviceId') // we can leave deviceid in localStorage even afetr logout
  localStorage.removeItem('name')
  localStorage.removeItem('accessToken')
  localStorage.removeItem('refreshToken')
  localStorage.removeItem('organizationId')
  localStorage.removeItem('appFlavour')
  localStorage.removeItem("isUserLoggedIn")
  localStorage.removeItem("appVersion")
  localStorage.removeItem("domainId")
  localStorage.removeItem("studentBatchId")
  localStorage.removeItem("studentCourseId")
}

